import React from "react";
import AppRoutes from "./routes/AppRoutes";
import { ChakraProvider } from "@chakra-ui/react";
import { theme } from "./utils/theme";
import { AuthProvider } from "./store/AuthContext";


function App() {
  return (
    <ChakraProvider theme={theme}>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </ChakraProvider>
  );
}

export default App;
